"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import _ from "lodash";
import { AccountSessionMixins } from "@/service/account-session";
import { StatisticsModel } from "@/models/costModels/Statistics.model";
import API from "@ym-framework/api-utils";
import BindVd from "@/views/costItems/components/dialog/BindVd.vue";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import UiDialog from "@/components/dialog/UiDialog.vue";
import i18n from "@/lang";
import UiSubmit from "@/components/form/UiSubmit.vue";
import WhaleBeanDialog from "./WhaleBeanSettingDialog.vue";
import ShowAmountTipDialog from "./ShowAmountTipDialog.vue";
import CompanyPaymentDialog from "./dialog/CompanyPaymentDialog.vue";
class AddCouponFormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.coupon_code = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("couponitem.please_enter_the_exchange_code"),
      trigger: "blur"
    }
  ])
], AddCouponFormController.prototype, "coupon_code", 2);
let AccountRecharge = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.overview = new StatisticsModel();
    this.products = new Array();
    this.recharge_amount = null;
    this.payment_way = "alipay";
    this.recharge_auto_amount = 100;
    this.jump_style = null;
    this.uiFormConttoller = new AddCouponFormController();
    this.show_foreign = false;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      if (this.$route.query.hasOwnProperty("name")) {
        this.jump_style = this.$route.query.name;
      }
      yield this.getCoin();
      yield this.getProducts();
      yield this.checkShowForeign();
    });
  }
  getCoin() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          "api://base.auth/api/v7/accounts/coststatistics"
        );
        this.overview = response.data;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
      }
    });
  }
  getProducts() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v8/goods/coin/purchase`
        );
        this.products = response.data.datas;
        this.recharge_amount = _.find(this.products, { type: "custom" });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  checkShowForeign() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v8/orders/show-foreign-payment`
        );
        let dashboardResponse = yield API.get(
          `api://base.auth.pro/v1/accounts/dashboard`
        );
        let vd_num = dashboardResponse.data.allVD;
        this.show_foreign = response.data.result && vd_num > 10;
      } catch (error) {
      }
    });
  }
  openBeanSetting() {
    return __async(this, null, function* () {
      yield this._whale_bean_dialog.open();
    });
  }
  openContactUs() {
    window.open("https://wpa1.qq.com/FzfSmq8R?_type=wpa&qidian=true", "_blank");
  }
  // changePaymentProduct() {
  //   this.recharge_amount = _.find(this.products, { type: "custom" });
  // }
  checkConfirm(flag) {
    return __async(this, null, function* () {
      if (flag) {
        yield this.startPayment();
      } else {
        return;
      }
    });
  }
  checkPayment() {
    return __async(this, null, function* () {
      if (this.recharge_auto_amount > 1e3) {
        yield this._show_amount_tip_dialog.open(this.recharge_auto_amount);
      } else {
        yield this.startPayment();
      }
    });
  }
  startPayment() {
    return __async(this, null, function* () {
      try {
        let response = yield API.post(
          `api://base.auth/api/v7/orders/coin/pay`,
          {
            callback: `https://app.kuajingvs.com/paymentcomplete?callback=/payment/token`,
            pay_type: this.payment_way,
            product: {
              goods_spec_guid: this.recharge_amount.guid
            },
            quantity: this.recharge_auto_amount
            // quantity:
            //   this.recharge_amount.type === "fixed"
            //     ? 1
            //     : this.recharge_auto_amount,
          }
        );
        let model = response.data;
        let _order_id = response.data.order.id;
        let _qr_url = response.data.url;
        if (this.payment_way === "wxpay") {
          this.$router.push({
            name: "PaymentConfirmation",
            query: {
              t: "wechat",
              jump: this.jump_style === null ? "" : this.jump_style,
              id: _order_id,
              qr: _qr_url,
              style: "coin"
            }
          });
        }
        if (this.payment_way === "alipay") {
          this.$router.push({
            name: "PaymentConfirmation",
            query: {
              t: "alipay",
              jump: this.jump_style === null ? "" : this.jump_style,
              id: _order_id,
              qr: _qr_url,
              style: "coin"
            }
          });
        }
        if (this.payment_way === "payssion.alipay") {
          let real_url = JSON.parse(_qr_url);
          window.open(real_url.url, "__blank");
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  toCoupon() {
    return __async(this, null, function* () {
      try {
        let response = yield API.post(
          `api://base.auth/api/v7/discount_coupon_exchanges/exchange_discount_coupon`,
          {
            exchange_code: this.uiFormConttoller.coupon_code
          }
        );
        this.$message.success(
          this.$t("couponitem.the_exchange_code_was_successfully_used_")
        );
        this.dialogclose();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  dialogclose() {
    this.uiFormConttoller.coupon_code = "";
    this._couponDialog.hide();
  }
  bindVD() {
    this.$router.push({
      name: "vdcardItem"
    });
  }
  refresh() {
    return __async(this, null, function* () {
      yield this.getCoin();
    });
  }
  CachCoupon() {
    return __async(this, null, function* () {
      this.$router.push({
        name: "couponItem"
      });
    });
  }
  openCompanyPayment() {
    var _a;
    if ((_a = this.$session) == null ? void 0 : _a.marks.any("PUBLIC_PAYMENT_BLOCK")) {
      this.$message.info(this.$t("recharge.show_contact_us_tip"));
    } else {
      this._company_payment_dialog.open();
    }
  }
  goHelp(no) {
    window.open(`https://www.kuajingvs.com/help2/${no}`);
  }
  openAdv() {
    window.open(`https://www.kuajingvs.com/article/25151`, "__blank");
  }
};
__decorateClass([
  Ref("whale-bean-dialog")
], AccountRecharge.prototype, "_whale_bean_dialog", 2);
__decorateClass([
  Ref("bind_vd")
], AccountRecharge.prototype, "_bind_vd", 2);
__decorateClass([
  Ref("coupon-add")
], AccountRecharge.prototype, "_couponDialog", 2);
__decorateClass([
  Ref("show-amount-tip-dialog")
], AccountRecharge.prototype, "_show_amount_tip_dialog", 2);
__decorateClass([
  Ref("company-payment-dialog")
], AccountRecharge.prototype, "_company_payment_dialog", 2);
AccountRecharge = __decorateClass([
  Component({
    components: {
      BindVd,
      UiDialog,
      UiForm,
      UiSubmit,
      WhaleBeanDialog,
      ShowAmountTipDialog,
      CompanyPaymentDialog
    }
  })
], AccountRecharge);
export {
  AccountRecharge as default
};
